"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
/**
 * @param {{
 * className?: string;
 * fill?: React.CSSProperties['fill'] | string | CallableFunction;
 * kind?: 'hollow'|'solid';
 * height?: string|number;
 * onClick?: CallableFunction;
 * onHover?: CallableFunction;
 * tickFillColor?: string;
 * width?: string|number;
 * [key: string]: any;
 * }} props - Component props.
 */
function Success(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    fill = _ref.fill,
    _ref$kind = _ref.kind,
    kind = _ref$kind === void 0 ? 'solid' : _ref$kind,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '100%' : _ref$height,
    _ref$tickFillColor = _ref.tickFillColor,
    tickFillColor = _ref$tickFillColor === void 0 ? '#fff' : _ref$tickFillColor,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '100%' : _ref$width,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$onHover = _ref.onHover,
    onHover = _ref$onHover === void 0 ? function () {} : _ref$onHover;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: className,
    onClick: onClick,
    onMouseEnter: onHover,
    onMouseLeave: onHover,
    role: "none"
  }, kind === 'hollow' && /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/_react.default.createElement("title", null, "Success"), /*#__PURE__*/_react.default.createElement("path", {
    d: "M32,0A32,32,0,1,0,64,32,32,32,0,0,0,32,0Zm0,60A28,28,0,1,1,60,32,28,28,0,0,1,32,60Z",
    style: {
      fill: fill
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M45.59,21.58L25,42.06l-6.51-7.58a2,2,0,1,0-3,2.61L23.4,46.3a2,2,0,0,0,1.44.7h0.08a2,2,0,0,0,1.41-.58l22.08-22A2,2,0,1,0,45.59,21.58Z",
    style: {
      fill: fill
    }
  })), kind === 'solid' && /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/_react.default.createElement("title", null, "Success"), /*#__PURE__*/_react.default.createElement("path", {
    d: "M32,0A32,32,0,1,0,64,32,32,32,0,0,0,32,0ZM48.41,24.42l-22.08,22a2,2,0,0,1-1.41.58H24.84a2,2,0,0,1-1.44-.7l-7.92-9.22a2,2,0,1,1,3-2.61L25,42.06,45.59,21.58A2,2,0,1,1,48.41,24.42Z",
    style: {
      fill: fill
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M45.59,21.58L25,42.06l-6.51-7.58a2,2,0,1,0-3,2.61L23.4,46.3a2,2,0,0,0,1.44.7h0.08a2,2,0,0,0,1.41-.58l22.08-22A2,2,0,1,0,45.59,21.58Z",
    style: {
      fill: tickFillColor
    }
  })));
}
var _default = exports.default = Success;